module.exports = __webpack_public_path__ + "static/spiral-f404c38ef77efca04965e875bde2b30f.svg";